import { Message } from "@/models";
import axios from "axios";

export default class MessageService {
    public async GetMessagesByHousingCompany(housingCompanyId: number): Promise<Message[]> { 
        const messages = (await axios.get("messages/by-housing-company-id", { params: { housingCompanyId }})).data;

        return messages;
    }

    public async GetMessage(id: number): Promise<Message | null> {
        const message = (await axios.get(`messages/${id}`)).data;
        return message;
    }
}
